import { useMemo } from 'react';

import { useCRMData } from './useCRMData';

export const immediateCompletion = ['cod', 'other', 'transfer'];
export const handlesPaymentsStatus = (provider) => !immediateCompletion.includes(provider);

export const usePaymentConfigs = () => {
    const { payments } = useCRMData();

    return useMemo(() => {
        const providers = Object.entries(payments || {}).filter(([, config]) => config.enabled);
        const immediate = [];
        const online = [];

        for (const entry of providers) {
            if (handlesPaymentsStatus(entry[0])) {
                online.push(entry);
            } else {
                immediate.push(entry);
            }
        }

        return {
            payments,
            providers,
            immediate,
            online,
            isSingular: providers.length <= 1,
            isSingularOnline: online.length <= 1,
        };
    }, [payments]);
};
